import $ from "../../../../libs/jquery-3.3.1.min.js";
import {gsap} from "../../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {TranslatableText} from "./TranslatableText";
import {AppearingContainer} from "./AppearingContainer";
import {InteractiveButton} from "./InteractiveButton";
import {Point} from "pixi.js";

// Constructor
export class PhotoCreditsPopup extends AppearingContainer {

  constructor(x, y, color, appearingScreenPercent, creditsData, game) {
    if (creditsData === undefined) return; // stop here if screen doesn't exist
    super(appearingScreenPercent, game);

    // top left position
    this.pos = {
      x: x,
      y: y
    }

    // Popup settings
    this.scaleFactor = 0.6;
    this.popupPadding = 128 * this.scaleFactor;

    this.buttonSize = 60;

    this.popupTextStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 96 * this.scaleFactor,
      lineHeight: 106 * this.scaleFactor,
      fill: "#343B6F",
    });

    this.build(creditsData);
  }

  build(creditsData) {

    this.popupContainer = new PIXI.Container();
    this.popupContainer.eventMode = "none";

    // Build the info icon button
    this.buttonContainer = this.buildButton();
    this.buttonContainer.position = this.pos;

    // Popup
    if (creditsData.text) {
      // Popup text
      const popupTextEN = new TranslatableText(creditsData.text.en, this.popupTextStyle, "en", this.game).getText();
      popupTextEN.position.set(this.popupPadding, this.popupPadding * 2);
      const popupTextFR = new TranslatableText(creditsData.text.fr, this.popupTextStyle, "fr", this.game).getText();
      popupTextFR.position.set(this.popupPadding, this.popupPadding * 2);

      // Calculate popup width/height
      let width = Math.max(popupTextEN.width, popupTextFR.width);
      width = this.popupPadding + width + (this.popupPadding * 2);

      let height = Math.max(popupTextEN.height, popupTextFR.height);
      height = (this.popupPadding * 2) + height + this.popupPadding;

      // Background
      const popupBackground = new PIXI.Graphics()
        .roundRect(0, 0, width, height, 32)
        .fill(0xFFFF9F);

      // Close button
      this.closeButton = new InteractiveButton(this.hidePopup.bind(this), true, "audio/MAF_Reactif_Boites.oga");
      let closeButtonSprite = new PIXI.Sprite(this.game.assets.cross);
      closeButtonSprite.setSize(64 * this.scaleFactor, 64 * this.scaleFactor);
      this.closeButton.addChild(closeButtonSprite);
      this.closeButton.position.set(popupBackground.width - this.closeButton.width - this.popupPadding, this.popupPadding + (20 * this.scaleFactor));

      this.popupContainer.addChild(popupBackground);
      this.popupContainer.addChild(this.closeButton);
      this.popupContainer.addChild(popupTextEN);
      this.popupContainer.addChild(popupTextFR);
      this.popupContainer.position.set(-this.popupContainer.width / 2, -this.popupContainer.height / 2);
      this.popupContainer.alpha = 0.0;
    }

    this.reset();
  }

  buildButton() {
    const container = new InteractiveButton(this.showPopup.bind(this), false, "audio/MAF_Reactif_Boites.oga");

    const buttonBackground = new PIXI.Sprite(this.game.assets["info"]);
    buttonBackground.width = buttonBackground.height = this.buttonSize;

    container.pivot.set(this.buttonSize / 2, this.buttonSize / 2);

    container.addChild(buttonBackground);
    return container;
  }

  getButton() {
    return this.buttonContainer;
  }

  getPopup() {
    return this.popupContainer;
  }

  showPopup() {
    this.game.disableUI();
    this.buttonContainer.eventMode = "none";
    this.closeButton.eventMode = "static";
    this.popupContainer.eventMode = "passive";
    gsap.to(this.popupContainer, {alpha: 1.0, duration: 0.4, ease: 'sine.inOut'})
  }

  hidePopup() {
    this.game.enableUI();
    this.buttonContainer.eventMode = "static";
    this.closeButton.eventMode = "none";
    this.popupContainer.eventMode = "none";
    gsap.to(this.popupContainer, {alpha: 0.0, duration: 0.4, ease: 'sine.inOut'});
  }

  buildAnimations() {
    this.inAnimation = gsap.fromTo(this.buttonContainer,
      {
        pixi: {
          scale: 0
        }
      },
      {
        pixi: {
          scale: 1
        },
        ease: "back.out(1.7)",
        immediateRender: true, // makes the circle scale 0 immediately, even if tween is paused
        paused: true,
        duration: 0.5
      }
    )
  }

  // Function called when the animateIn fonction from the AppearingContainer Class is called
  // Useful to do more actions without overwriting the base animateIn function
  animateInAddons() {
    // Enable interaction with popup trigger button
    this.closeButton.eventMode = "none";
    this.popupContainer.eventMode = "none";
    this.enable();
  }

  enable() {
    this.buttonContainer.eventMode = "static";
  }

  disable() {
    this.buttonContainer.eventMode = "none";
    this.closeButton.eventMode = "none";
    this.popupContainer.eventMode = "none";
  }

  getPositionOnScreen() {
    return this.buttonContainer.toGlobal(new Point(0, 0));
  }

  reset() {
    super.reset();
  }

}
